import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4902fab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 divTitulo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold spanTitulo" }, "Detalles del vehículo |", -1))
const _hoisted_3 = {
  class: "fs-sm",
  style: {"color":"#8C8F93 !important"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm" }, "Detalles del vehículo", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4" }
const _hoisted_7 = { class: "detalleVehiculo text-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "text-center bgColumn",
  style: {"border-radius":"0px 0px 10px 10px"}
}
const _hoisted_10 = { class: "fs-2 fw-bold" }
const _hoisted_11 = { class: "fs-base" }
const _hoisted_12 = { class: "text-center bgColumn mt-10 d-inline-flex row dropDownClass" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"40px","margin-right":"5px"} }, "Estatus", -1))
const _hoisted_14 = {
  key: 2,
  class: "badge badge-success badge-lg mb-2 mt-2 p-4"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"40px","margin-right":"5px"} }, "Estatus", -1))
const _hoisted_16 = {
  key: 0,
  class: "badge badge-success badge-lg mb-2 mt-2 p-4"
}
const _hoisted_17 = {
  key: 1,
  class: "badge badge-primary badge-lg mb-2 mt-2 p-4"
}
const _hoisted_18 = {
  key: 2,
  class: "badge badge-success badge-lg mb-2 mt-2 p-4"
}
const _hoisted_19 = {
  key: 0,
  class: "col-8 offset-2 text-start",
  style: {"background-color":"#393840","border-radius":"0px 0px 10px 10px"}
}
const _hoisted_20 = { style: {"list-style-type":"none","padding":"0"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Selecciona el estatus")
], -1))
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_24 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_25 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_26 = { class: "accordion-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-5 fw-bold",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_1",
    "aria-expanded": "true",
    "aria-controls": "kt_accordion_1_body_1"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Detalles del vehículo")
  ])
], -1))
const _hoisted_28 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_29 = { class: "accordion-body text-start" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "VIN", -1))
const _hoisted_31 = { class: "textDato mb-1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Año", -1))
const _hoisted_34 = { class: "textDato mb-1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Marca", -1))
const _hoisted_37 = { class: "textDato mb-1" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Modelo", -1))
const _hoisted_40 = { class: "textDato mb-1" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Versión", -1))
const _hoisted_43 = { class: "textDato mb-1" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Tipo", -1))
const _hoisted_46 = { class: "textDato mb-1" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Transmisión", -1))
const _hoisted_49 = { class: "textDato mb-1" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Color", -1))
const _hoisted_52 = { class: "textDato mb-1" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold" }, "Kilometraje", -1))
const _hoisted_55 = { class: "textDato mb-1" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_58 = { class: "pestañas" }
const _hoisted_59 = { class: "nav nav-tabs nav-line-tabs mb-5 fs-6" }
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\" data-v-4902fab2><a class=\"nav-link active colorPestañas\" data-bs-toggle=\"tab\" href=\"#kt_tab_pane_1\" data-v-4902fab2>Descripción</a></li><li class=\"nav-item\" data-v-4902fab2><a class=\"nav-link colorPestañas\" data-bs-toggle=\"tab\" href=\"#kt_tab_pane_2\" data-v-4902fab2>Desperfectos</a></li><li class=\"nav-item\" data-v-4902fab2><a class=\"nav-link colorPestañas\" data-bs-toggle=\"tab\" href=\"#kt_tab_pane_3\" data-v-4902fab2>Fotografías</a></li><li class=\"nav-item\" data-v-4902fab2><a class=\"nav-link colorPestañas\" data-bs-toggle=\"tab\" href=\"#kt_tab_pane_4\" data-v-4902fab2>Métricas</a></li>", 4)
const _hoisted_64 = { class: "nav-item" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link colorPestañas",
  "data-bs-toggle": "tab",
  href: "#kt_tab_pane_5"
}, "Apartado", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_68 = {
  class: "tab-pane fade show active",
  role: "tabpanel",
  id: "kt_tab_pane_1"
}
const _hoisted_69 = {
  class: "bgPestañas",
  style: {"border-radius":"10px"}
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row borderBottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "fs-5 fw-bold" }, "Descripción adicional")
  ])
], -1))
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-12 mt-5" }
const _hoisted_73 = { class: "ulDueno" }
const _hoisted_74 = { class: "liBorderBottom" }
const _hoisted_75 = { class: "divList" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "Único dueno", -1))
const _hoisted_77 = { class: "fr" }
const _hoisted_78 = { class: "liBorderBottom" }
const _hoisted_79 = { class: "divList" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "Servicios en agencia", -1))
const _hoisted_81 = { class: "fr" }
const _hoisted_82 = { class: "liBorderBottom" }
const _hoisted_83 = { class: "divList" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "Certificado", -1))
const _hoisted_85 = { class: "fr" }
const _hoisted_86 = { class: "col-12 mt-5" }
const _hoisted_87 = {
  class: "bgPestañas mt-4",
  style: {"border-radius":"10px"},
  id: "kt_tab_pane_1"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row borderBottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "fs-5 fw-bold" }, "Características")
  ])
], -1))
const _hoisted_89 = { class: "col-12 mt-5" }
const _hoisted_90 = { class: "divList d-block" }
const _hoisted_91 = { class: "fl" }
const _hoisted_92 = {
  key: 0,
  class: "fr"
}
const _hoisted_93 = {
  key: 1,
  class: "fr"
}
const _hoisted_94 = {
  key: 2,
  class: "fr"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_97 = {
  class: "tab-pane fade",
  id: "kt_tab_pane_2",
  role: "tabpanel"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row borderBottom bgPestañas",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "fs-5 fw-bold" }, "Descripción de daños")
  ])
], -1))
const _hoisted_99 = {
  class: "row bgPestañas",
  style: {"border-radius":"0px 0px 10px 10px"}
}
const _hoisted_100 = { class: "col-12 mt-5" }
const _hoisted_101 = { class: "row mt-5" }
const _hoisted_102 = { class: "col-12 p-0" }
const _hoisted_103 = {
  id: "carouselExampleControls",
  class: "carousel slide",
  "data-bs-interval": "false",
  "data-bs-ride": "carousel"
}
const _hoisted_104 = { class: "carousel-inner" }
const _hoisted_105 = ["src"]
const _hoisted_106 = { class: "carousel-caption" }
const _hoisted_107 = { class: "counterCaption" }
const _hoisted_108 = {
  class: "carousel-control-prev",
  role: "button"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_112 = [
  _hoisted_110,
  _hoisted_111
]
const _hoisted_113 = { class: "row" }
const _hoisted_114 = { class: "col-12 mt-5 p-0" }
const _hoisted_115 = { class: "containerImages" }
const _hoisted_116 = { class: "listadoImagenes p-0" }
const _hoisted_117 = ["src", "onClick"]
const _hoisted_118 = {
  class: "tab-pane fade",
  id: "kt_tab_pane_3",
  role: "tabpanel"
}
const _hoisted_119 = { class: "row mt-5" }
const _hoisted_120 = { class: "col-12 p-0" }
const _hoisted_121 = {
  id: "carouselExampleControls2",
  class: "carousel slide",
  "data-bs-interval": "false",
  "data-bs-ride": "carousel"
}
const _hoisted_122 = { class: "carousel-inner" }
const _hoisted_123 = ["src"]
const _hoisted_124 = { class: "carousel-caption" }
const _hoisted_125 = { class: "counterCaption" }
const _hoisted_126 = {
  class: "carousel-control-prev",
  role: "button"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_128 = {
  class: "carousel-control-next",
  role: "button"
}
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_130 = { class: "row" }
const _hoisted_131 = { class: "col-12 mt-5 p-0" }
const _hoisted_132 = { class: "containerImages" }
const _hoisted_133 = { class: "listadoImagenes p-0" }
const _hoisted_134 = ["src", "onClick"]
const _hoisted_135 = {
  class: "tab-pane fade",
  id: "kt_tab_pane_4",
  role: "tabpanel"
}
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row borderBottom bgPestañas",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "fs-2 fw-bold" }, "Métricas del vehículo")
  ])
], -1))
const _hoisted_137 = {
  class: "row bgPestañas",
  style: {"border-radius":"0px 0px 10px 10px","padding":"0px !important"}
}
const _hoisted_138 = { class: "row" }
const _hoisted_139 = {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 border1",
  style: {"border-right":"2px solid #262831","padding":"15px !important"}
}
const _hoisted_140 = { class: "row" }
const _hoisted_141 = {
  class: "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center",
  style: {"padding":"20px 0px 20px 20px"}
}
const _hoisted_142 = { style: {"padding":"15px","background-color":"#0860F0","margin":"10px 10px"} }
const _hoisted_143 = { class: "col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 text-center" }
const _hoisted_144 = {
  class: "fs-1 fw-bold",
  style: {"margin-bottom":"0px","margin-top":"10px"}
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Citas agendadas", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#17BF63"} }, null, -1))
const _hoisted_147 = {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 border2",
  style: {"padding":"15px !important"}
}
const _hoisted_148 = { class: "row" }
const _hoisted_149 = {
  class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center",
  style: {"padding":"20px 0px 20px 20px"}
}
const _hoisted_150 = { style: {"padding":"15px","background-color":"#F64E60","margin":"10px 10px"} }
const _hoisted_151 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 text-center" }
const _hoisted_152 = {
  class: "fs-1 fw-bold",
  style: {"margin-bottom":"0px","margin-top":"10px"}
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Veces apartado", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#17BF63"} }, null, -1))
const _hoisted_155 = { class: "row" }
const _hoisted_156 = {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 border3",
  style: {"border-right":"2px solid #262831","border-top":"2px solid #262831","padding":"15px !important"}
}
const _hoisted_157 = { class: "row" }
const _hoisted_158 = {
  class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center",
  style: {"padding":"20px 0px 20px 20px"}
}
const _hoisted_159 = { style: {"padding":"15px","background-color":"#15B35D","margin":"10px 10px"} }
const _hoisted_160 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 text-center" }
const _hoisted_161 = {
  class: "fs-1 fw-bold",
  style: {"margin-bottom":"0px","margin-top":"10px"}
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Views", -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","color":"#17BF63"} }, null, -1))
const _hoisted_164 = {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 border4",
  style: {"border-top":"2px solid #262831","padding":"15px !important"}
}
const _hoisted_165 = { class: "row" }
const _hoisted_166 = {
  class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center",
  style: {"padding":"20px 0px 20px 20px"}
}
const _hoisted_167 = { style: {"padding":"15px","background-color":"#272A31","margin":"10px 10px"} }
const _hoisted_168 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 text-center" }
const _hoisted_169 = {
  class: "fs-1 fw-bold",
  style: {"margin-bottom":"0px","margin-top":"10px","padding-left":"15px"}
}
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "En piso", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_tab_pane_5",
  role: "tabpanel"
}, null, -1))
const _hoisted_172 = {
  class: "modal fade",
  id: "deleteVehicleModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "venderVehicleRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_173 = { class: "modal-dialog modal-dialog-centered mw-350px" }
const _hoisted_174 = { class: "modal-content rounded" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header pb-0 border-0 w-100",
  style: {"border-bottom":"1px solid #393840 !important"}
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3 text-left" }, "Vender vehículo")
], -1))
const _hoisted_176 = {
  class: "modal-body pt-0",
  style: {"padding-left":"35px"}
}
const _hoisted_177 = {
  class: "row mb-2",
  style: {"margin-top":"10px"}
}
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-2 text-start ps-0" }, [
  /*#__PURE__*/_createTextVNode(" ¿Desea vender el vehículo? Este dejará de "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" estar disponible para otra venta ")
], -1))
const _hoisted_179 = { class: "col-12 text-center mt-5" }
const _hoisted_180 = {
  style: {"list-style-type":"none","display":"inline-flex"},
  class: "p-0"
}
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { style: {"margin-right":"5px"} }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal",
    type: "button"
  }, " Descartar ")
], -1))
const _hoisted_182 = {
  class: "modal fade",
  id: "deleteVehicleModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "disponibleVehicleRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_183 = { class: "modal-dialog modal-dialog-centered mw-350px" }
const _hoisted_184 = { class: "modal-content rounded" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header pb-0 border-0 w-100",
  style: {"border-bottom":"1px solid #393840 !important"}
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3 text-left" }, "Estatus del vehículo")
], -1))
const _hoisted_186 = {
  class: "modal-body pt-0",
  style: {"padding-left":"35px"}
}
const _hoisted_187 = {
  class: "row mb-2",
  style: {"margin-top":"10px"}
}
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-2 text-start ps-0" }, [
  /*#__PURE__*/_createTextVNode(" ¿Desea cambiar el estatus del vehículo? Este "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" aparecerá para compra en el sitio ")
], -1))
const _hoisted_189 = { class: "col-12 text-center mt-5" }
const _hoisted_190 = {
  style: {"list-style-type":"none","display":"inline-flex"},
  class: "p-0"
}
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { style: {"margin-right":"5px"} }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal",
    type: "button"
  }, " Descartar ")
], -1))
const _hoisted_192 = {
  class: "modal fade",
  id: "sellVehicleModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "sellVehicleRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_193 = { class: "modal-dialog modal-dialog-centered mw-400px" }
const _hoisted_194 = { class: "modal-content rounded" }
const _hoisted_195 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header pb-0 border-0\" data-v-4902fab2><h1 class=\"mb-3 text-center mt-5 w-100\" data-v-4902fab2>Vehículo vendido</h1></div><div class=\"modal-body text-center pt-0 pb-0\" data-v-4902fab2><div class=\"col-12\" data-v-4902fab2><p data-v-4902fab2>Se ha vendido de manera exitosa el vehículo</p><div class=\"swal2-icon swal2-success swal2-icon-show\" style=\"display:flex;\" data-v-4902fab2><div class=\"swal2-success-circular-line-left\" style=\"background-color:rgb(25, 31, 38);\" data-v-4902fab2></div><span class=\"swal2-success-line-tip\" data-v-4902fab2></span> <span class=\"swal2-success-line-long\" data-v-4902fab2></span><div class=\"swal2-success-ring\" data-v-4902fab2></div> <div class=\"swal2-success-fix\" style=\"background-color:rgb(25, 31, 38);\" data-v-4902fab2></div><div class=\"swal2-success-circular-line-right\" style=\"background-color:rgb(25, 31, 38);\" data-v-4902fab2></div></div></div></div>", 2)
const _hoisted_197 = { class: "col-12 text-center mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.titulo), 1),
      _createTextVNode(),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _ctx.portada,
            alt: "",
            class: "portada mt-5 mb-5"
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.nombreAuto), 1),
          _createElementVNode("p", _hoisted_11, "$ " + _toDisplayString(_ctx.precio), 1),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.tipoRol == 'Múltiples agencias')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.dropShow ? 'col-8 offset-2': 'col-12'),
                  style: _normalizeStyle(_ctx.dropShow ? 'background-color: #28272C; border-radius: 10px 10px 0px 0px;':'')
                }, [
                  _hoisted_13,
                  (_ctx.status == 'Disponible')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-success mb-2 mt-2",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mostrarDrop && _ctx.mostrarDrop(...args)))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.status) + " ", 1),
                        _createVNode(_component_inline_svg, {
                          src: "media/icons/iconsax/dropWhite.svg",
                          style: {"margin-left":"2px"}
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.status == 'Apartado')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-primary mb-2 mt-2",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mostrarDrop && _ctx.mostrarDrop(...args)))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.status) + " ", 1),
                        _createVNode(_component_inline_svg, {
                          src: "media/icons/iconsax/dropWhite.svg",
                          style: {"margin-left":"2px"}
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.status == 'Vendido')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.status), 1))
                    : _createCommentVNode("", true)
                ], 6))
              : _createCommentVNode("", true),
            (_ctx.tipoRol == 'Corporativo')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.dropShow ? 'col-8 offset-2': 'col-12'),
                  style: _normalizeStyle(_ctx.dropShow ? 'background-color: #28272C; border-radius: 10px 10px 0px 0px;':'')
                }, [
                  _hoisted_15,
                  (_ctx.status == 'Disponible')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.status), 1))
                    : _createCommentVNode("", true),
                  (_ctx.status == 'Apartado')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.status), 1))
                    : _createCommentVNode("", true),
                  (_ctx.status == 'Vendido')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.status), 1))
                    : _createCommentVNode("", true)
                ], 6))
              : _createCommentVNode("", true),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_ctx.dropShow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("ul", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("li", _hoisted_22, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-success w-100",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.venderModal && _ctx.venderModal(...args)))
                          }, "Vendido")
                        ]),
                        (_ctx.status == 'Disponible')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-primary w-100",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.apartarVehiculo && _ctx.apartarVehiculo(...args)))
                              }, "Apartado")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.status == 'Apartado')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-primary w-100",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showChangeStatus && _ctx.showChangeStatus(...args)))
                              }, "Disponible")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.vin), 1),
                  _hoisted_32,
                  _hoisted_33,
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.anio), 1),
                  _hoisted_35,
                  _hoisted_36,
                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.brand), 1),
                  _hoisted_38,
                  _hoisted_39,
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.model), 1),
                  _hoisted_41,
                  _hoisted_42,
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.version), 1),
                  _hoisted_44,
                  _hoisted_45,
                  _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.tipo), 1),
                  _hoisted_47,
                  _hoisted_48,
                  _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.transmision), 1),
                  _hoisted_50,
                  _hoisted_51,
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.color), 1),
                  _hoisted_53,
                  _hoisted_54,
                  _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.kilometraje) + " km", 1),
                  _hoisted_56
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("ul", _hoisted_59, [
            _hoisted_60,
            _withDirectives(_createElementVNode("li", _hoisted_64, _hoisted_66, 512), [
              [_vShow, false]
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("ul", _hoisted_73, [
                      _createElementVNode("li", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _hoisted_76,
                          _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.dueno), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.servicios), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.certificado), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.descAdicional), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specs, (spec) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_90, [
                      _createElementVNode("span", _hoisted_91, _toDisplayString(spec.name), 1),
                      (spec.value == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_92, "Si"))
                        : _createCommentVNode("", true),
                      (spec.value == false)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_93, "No"))
                        : _createCommentVNode("", true),
                      (spec.value !== false && spec.value !== true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(spec.value), 1))
                        : _createCommentVNode("", true),
                      _hoisted_95,
                      _hoisted_96
                    ]))
                  }), 256))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.desperfectoDescription), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desperfectoImages, (img, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["carousel-item", index == 0 ? 'active':'']),
                          key: index
                        }, [
                          _createElementVNode("img", {
                            class: "d-block w-100 imgCarousel",
                            src: _ctx.desperfectoImages[_ctx.indexImageDesperfectos],
                            alt: "First slide"
                          }, null, 8, _hoisted_105),
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.indexImageDesperfectos + 1) + " - " + _toDisplayString(_ctx.desperfectoImages.length), 1)
                          ])
                        ], 2))
                      }), 128))
                    ]),
                    _createElementVNode("a", _hoisted_108, [
                      _withDirectives(_createElementVNode("span", {
                        class: "carousel-control-prev-icon",
                        "aria-hidden": "true",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevImageDesperfectos && _ctx.prevImageDesperfectos(...args)))
                      }, null, 512), [
                        [_vShow, _ctx.indexImageDesperfectos > 0 && _ctx.desperfectoImages.length > 0]
                      ]),
                      _hoisted_109
                    ]),
                    _withDirectives(_createElementVNode("a", {
                      class: "carousel-control-next",
                      role: "button",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextImageDesperfectos && _ctx.nextImageDesperfectos(...args)))
                    }, _hoisted_112, 512), [
                      [_vShow, _ctx.desperfectoImages.length > 0 && (_ctx.indexImageDesperfectos + 1) < _ctx.desperfectoImages.length]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("ul", _hoisted_116, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desperfectoImages, (img, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "liAbsolute",
                          key: index
                        }, [
                          _createElementVNode("img", {
                            class: "vehiculoImagen",
                            src: img,
                            alt: "Automóvil",
                            onClick: ($event: any) => (_ctx.setImageDesperfectos(index))
                          }, null, 8, _hoisted_117)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleImages, (img, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["carousel-item", index == 0 ? 'active':'']),
                          key: index
                        }, [
                          _createElementVNode("img", {
                            class: "d-block w-100 imgCarousel",
                            src: _ctx.vehicleImages[_ctx.indexImageFotos],
                            alt: "First slide"
                          }, null, 8, _hoisted_123),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.indexImageFotos + 1) + " - " + _toDisplayString(_ctx.vehicleImages.length), 1)
                          ])
                        ], 2))
                      }), 128))
                    ]),
                    _createElementVNode("a", _hoisted_126, [
                      _withDirectives(_createElementVNode("span", {
                        class: "carousel-control-prev-icon",
                        "aria-hidden": "true",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prevImageFotos && _ctx.prevImageFotos(...args)))
                      }, null, 512), [
                        [_vShow, _ctx.indexImageFotos > 0 && _ctx.vehicleImages.length > 0]
                      ]),
                      _hoisted_127
                    ]),
                    _createElementVNode("a", _hoisted_128, [
                      _withDirectives(_createElementVNode("span", {
                        class: "carousel-control-next-icon",
                        "aria-hidden": "true",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextImageFotos && _ctx.nextImageFotos(...args)))
                      }, null, 512), [
                        [_vShow, _ctx.vehicleImages.length > 0 && (_ctx.indexImageFotos + 1) < _ctx.vehicleImages.length]
                      ]),
                      _hoisted_129
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("ul", _hoisted_133, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleImages, (img, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "liAbsolute",
                          key: index
                        }, [
                          _createElementVNode("img", {
                            class: "vehiculoImagen",
                            src: img,
                            alt: "Automóvil",
                            onClick: ($event: any) => (_ctx.setImageFotos(index))
                          }, null, 8, _hoisted_134)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_135, [
              _hoisted_136,
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("span", _hoisted_142, [
                          _createVNode(_component_inline_svg, { src: "media/icons/iconsax/calendar.svg" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("h1", _hoisted_144, _toDisplayString(_ctx.citas_agendadas), 1),
                        _hoisted_145,
                        _hoisted_146
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _createElementVNode("div", _hoisted_149, [
                        _createElementVNode("span", _hoisted_150, [
                          _createVNode(_component_inline_svg, { src: "media/icons/iconsax/message-text.svg" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("h1", _hoisted_152, _toDisplayString(_ctx.veces_apartado), 1),
                        _hoisted_153,
                        _hoisted_154
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_155, [
                  _createElementVNode("div", _hoisted_156, [
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("div", _hoisted_158, [
                        _createElementVNode("span", _hoisted_159, [
                          _createVNode(_component_inline_svg, { src: "media/icons/iconsax/eye.svg" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_160, [
                        _createElementVNode("h1", _hoisted_161, _toDisplayString(_ctx.views), 1),
                        _hoisted_162,
                        _hoisted_163
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _createElementVNode("span", _hoisted_167, [
                          _createVNode(_component_inline_svg, { src: "media/icons/iconsax/car.svg" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("h1", _hoisted_169, _toDisplayString(_ctx.piso) + " días", 1),
                        _hoisted_170
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_171
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_172, [
      _createElementVNode("div", _hoisted_173, [
        _createElementVNode("div", _hoisted_174, [
          _hoisted_175,
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("div", _hoisted_177, [
              _hoisted_178,
              _createElementVNode("div", _hoisted_179, [
                _createElementVNode("ul", _hoisted_180, [
                  _hoisted_181,
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.venderVehiculo && _ctx.venderVehiculo(...args)))
                    }, " Vender vehículo ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_182, [
      _createElementVNode("div", _hoisted_183, [
        _createElementVNode("div", _hoisted_184, [
          _hoisted_185,
          _createElementVNode("div", _hoisted_186, [
            _createElementVNode("div", _hoisted_187, [
              _hoisted_188,
              _createElementVNode("div", _hoisted_189, [
                _createElementVNode("ul", _hoisted_190, [
                  _hoisted_191,
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.disponibleVehiculo && _ctx.disponibleVehiculo(...args)))
                    }, " Actualizar estatus ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_192, [
      _createElementVNode("div", _hoisted_193, [
        _createElementVNode("div", _hoisted_194, [
          _hoisted_195,
          _createElementVNode("div", _hoisted_197, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.aceptarVendido && _ctx.aceptarVendido(...args)))
            }, "Aceptar")
          ])
        ])
      ])
    ], 512)
  ]))
}